import React, { useEffect, useState } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import CollapsableSection from 'modules/processes/components/ItemWizard/components/CollapsableSection'
import FilesList, {
  FileUpdates,
} from 'modules/processes/components/ItemWizard/components/FilesList/Files'
import { LoadingCollapsableCard } from 'modules/processes/components/ItemWizard/components/Form/Items/LoadingCollapsableCard'
import { useFiles } from 'modules/processes/hooks/useFiles'

const Attachments = () => {
  const { associatedTaskItem: item, form } = useFormProvider()
  const files = useFiles(item?.configurationId ?? undefined)

  const [fileUpdates, setFileUpdates] = useState<FileUpdates>()

  useEffect(() => {
    if (fileUpdates) {
      form.setValues({
        files: fileUpdates,
      })
    }
  }, [fileUpdates])

  if (files.loadingFiles) {
    return (
      <LoadingCollapsableCard
        title={i18n.t('processes.process_settings.wizard.attachments.label')}
      />
    )
  }

  return (
    <CollapsableSection
      title={i18n.t('processes.process_settings.wizard.attachments.label')}
      defaultOpen={!!files?.currentFiles?.length || !!form.values.files?.filesToAdd?.length}
    >
      <FilesList files={files} item={item} onFileUpdates={setFileUpdates} />
    </CollapsableSection>
  )
}

export default Attachments
